// extracted by mini-css-extract-plugin
export default {"submitWrapper":"styles_submitWrapper__SH2GH"};